module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer_wrape"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../../assets/images/client/iyunxiao_logo.png"),
      "alt": ""
    }
  }), _c('a', {
    staticClass: "btn",
    attrs: {
      "href": (_vm.jumpDomain + "/#01"),
      "target": "_blank"
    }
  }, [_vm._v("立即咨询")]), _c('p', {
    staticClass: "text"
  }, [_vm._v("电话：400-616-8079")])]), _c('div', {
    staticClass: "product"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.navigation.product.name))]), _c('div', {
    staticClass: "productBox"
  }, [_c('div', {
    staticClass: "productName"
  }, _vm._l((_vm.navigation.product.kaoshi), function(item, key) {
    return _c('a', {
      key: key,
      attrs: {
        "target": "_blank",
        "href": ("" + _vm.jumpDomain + (item.to))
      }
    }, [_vm._v(_vm._s(item.name))])
  })), _c('div', {
    staticClass: "productName"
  }, _vm._l((_vm.navigation.product.tiku), function(item, key) {
    return _c('a', {
      key: key,
      attrs: {
        "target": "_blank",
        "href": ("" + _vm.jumpDomain + (item.to))
      }
    }, [_vm._v(_vm._s(item.name))])
  })), _c('div', {
    staticClass: "productName"
  }, _vm._l((_vm.navigation.product.paike), function(item, key) {
    return _c('a', {
      key: key,
      attrs: {
        "target": "_blank",
        "href": ("" + _vm.jumpDomain + (item.to))
      }
    }, [_vm._v(_vm._s(item.name))])
  }))])]), _c('div', {
    staticClass: "product"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.navigation.solution.name))]), _c('div', {
    staticClass: "productBox"
  }, [_c('div', {
    staticClass: "productName",
    staticStyle: {
      "margin-right": "50px"
    }
  }, _vm._l((_vm.navigation.solution.listL), function(item, key) {
    return _c('a', {
      key: key,
      attrs: {
        "target": "_blank",
        "href": ("" + _vm.jumpDomain + (item.to))
      }
    }, [_vm._v(_vm._s(item.name))])
  })), _c('div', {
    staticClass: "productName"
  }, _vm._l((_vm.navigation.solution.listR), function(item, key) {
    return _c('a', {
      key: key,
      attrs: {
        "target": "_blank",
        "href": ("" + _vm.jumpDomain + (item.to))
      }
    }, [_vm._v(_vm._s(item.name))])
  }))])]), _c('div', {
    staticClass: "product"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.navigation.yunxiao.name))]), _c('div', {
    staticClass: "productBox"
  }, [_c('div', {
    staticClass: "productName"
  }, _vm._l((_vm.navigation.yunxiao.list), function(item, key) {
    return _c('a', {
      key: key,
      attrs: {
        "target": "_blank",
        "href": ("" + _vm.jumpDomain + (item.to))
      }
    }, [_vm._v(_vm._s(item.name))])
  }))])]), _vm._m(0)]), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wechat"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("关注我们")]), _c('div', [_c('img', {
    attrs: {
      "src": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHAAAAB4CAMAAAAdbYYUAAAC3FBMVEUAAAD///////////////////////////////////////////////////8AAAD+/v/KysoFBQX19vX+/f3p6emUlJSlpaVxcXG6urobGxt3d3fIyMhFRUU/Pz9UVFTj4+MmJiYICAjo6OgxMTEqKiqOjo78/P3U1NSCgoIKCgq1tbUfHx8SEhJ9fX3Ozs4wMDDd3d2+vr5aWlpPT08QEBD7+vrS0tIsLCyqqqrt7e3Y2NiwsLCoqKienp4WFhb3+Piurq77+/uIiIhra2vu7u4hISFfX19WVlZKSkr5+fr39/bGxsazs7Pn5+egoKA6Ojr///5/f396enr09PTy8vKTk5Pf39/Q0NBycnI2Njb///wnJycMDAzLy8vExMTCwsKsrKyVlZVjY2Ps7Ozl5eXAwMAUFBSioqJwcHBRUVEYGBj//f/a2tqampqJiYl0dHRqampnZ2dBQUEjIyMODg7w8PCcnJyLi4t8fHxdXV0zMzP///iYmJiHh4eBgYFLS0v6/v3W1tbNzc2EhIRYWFhNTU1hYWFHR0fi4uLc3NykpKSWlpZsbGxJSUn9//+tra1tbW1lZWVEREQ9PT35///6/ve8vLy4uLh2dnZDQ0P/+/nh4eG9vb25ubmhoaH9//uS3v7k9PeH2vdfze+QkJBMTEz+/P+Y3P686vodtveN2PSc2+6s5eyA0uy3t7cbt/4CtP6H2fzH6PvO8foGs/p52Pn5+Pjp+Pg6vviX2/f//vMMsvK16fGj2O6P2etbxeoBqegFoOiW4f+d3P+S5P6P4v6H4f45yP3w+fyP6/xazfx+4vuO2PsJuvqQ4vkEqvmj4vis4/ZbxfbE4/XY9fS/6fSI1/MpsvOz4vAfsvAxuOs7uuhdwtjM0c7Bu8HAvbeL2/70+/xGw/vZ7vfW6vdLwPe58fWs6fRpyPRFwvFtyO9qx+0luu2U4Opox+Wo2OIZv+F1zdw+vtusuLVkAEo1AAAADXRSTlMA7vn148KRZF44MRcG0hB0ygAAE85JREFUaN7s1mtv0lAAxnG/wPMc2sI6rKiAIEQuOqk6ZaDipm6CcXO6xUvmbeqiTpn3eIn3e9T5RjPjK33rZ/ScttYOUKcxJib+XtBDS/rnHJqWRfjL/gf/B//toIDDEPhj/KC4ZFlWyAoIhXYirAb702LOGhr083OWVUUHAsssaaUQAtUhdbJ5ZxtpmeFhtjmOPkqrgFfkYxhwTZOr0UEaGUq7AQN1thlqCQ6xTR0nKS0HxshlfvA1aXQOTlN6p0ZhtrFagiFyeySgSS2MLkrrgcUq6BCAFYmYtRvAjVoe+FyrPa85hgXuRiJTnIUU1tiMREYjinrdTobagxMIuKeC7pL6QUUIAM63GCfV+voEpCRve8EMAl52DI4iPaI7BgGTWgLleDYbv+4F07piiKqur4gv1fUH7Nf1PJl1xGec4ArO6voWFTwFoXvSONIxGMHITCmnxLygfkzqTbvBTfJAaRy4WSrt31Yu5eLUJnNZ0up1bIMbjE/mJlRwDCKWc/SPfDeo09XvBMPwqCBwggpwTV2/ZfoQXOwkpT4VNIEZun4QzNFR9GZ4pq9x3AumGufJ2YHFQkwMDITF3QHfs0a3cIP7G40opS43qOpKTl9gMIxn5C436CoAhoEWB1mEIvCWyi8FS/Nn2OV9bpqu94AwWu93y3karvyfCK6PSZk1aypsnljzOnZN4KzaMywwrLaXVXBSjZYa2LfmRP8vBuma8oOuPLCKD9U1SKBGqQk0KQ2rnS4o48Fg9KcXTfVN0bE9GIwXk30wopQ7XyVfFAr5ZDLOZqHgBF8XCqt4MZksJpt3C9JMMHi/6IgNfjfoMwLB9ZBElEshzZEZoJ/zPIDUS48fFPCNLuDW5gdzftAAbCeocZ5PUFqCGQRsIA+1B5vmV2Pm2LgXvJA6Z5rdblCcNadTqT2meS51lDyaukouSX2c4g6gTx15QC5OXfCC181vxmbJ0EIeTw3yDi6R0zBUEDMkkFEvK9URkKNAUS3pGxK4QY6oIx8W8jy0tFZZOUNN68Y6cqv3G67VVtj2MHnGfklO2Bs1LW/bB/jItpcyauCKpq1Et6aVkTiotWpZUlGtJ8IOtVESibTQ64mdWOkHRW/YqlQOkpNTJbJUSYbDtyoVjfHKVFYF99brthhMJAbFlnoi4Z/IHdotQXRgQDnkLelRKAwCXtH3e//axJOnJ49DCBE6WdYhCTHXc3+TmuF4l3S2R8lSivWcEtjcc63EqNr3sMvxtFsIAenOU/f9GVEtq8GxzkGMkl/4MAumJaIoDP+Cc66w1iIi6gq62KuAgAomOgYWKnZ3txjY3d3d7dg59tjd44xjxzjj6B/wnr3Luvqhz3zBAsu799wT71KY1jbGGPKSRyy2L+oMB2KYNQsC6LKuPQCCZihoZVRop38IRhH9JMjzvrtYoRA0Ss8NxHDkrACBghN1j4iCpiAYgIIoAAUkT1kwBq2cnADiWOdggFDhwjWBcSDpdEZA6lGY05YEmzidnelgsFNQxhSsT08PcAraIc4pPAox4BxqyyPIgJiOWWzWTKqIWBsETuwJNPUaAFD9ZSkKnJqIDtFBTKpCdzTp8Kcga+n3VkabEpARhynbvERVVsfv93tVRRkJnkn+mQBDFKfXOxgxCZyFSju01VACijLGy+kUUEYBpzCiHFBs2FNRGnkjSqCs+NTcnaZ9C+pmHcFrOO/15rbFeqIGnCQSJMiArn8CcFYgpyfttBDsDHWK81IChTa0K5blMzSvYBHklLHDbBISeQWw3Iyvh28taQASxsRPGsHOZ31yMuJI6IbYG2AsCc6j0I7LNS1IsBq1z8qO5rU4A5s7piF2rTWSkWCBWmFg1R2LkBjiaMJoIo2v1QnYKMdoevt4h0NlUIrO9bKWA2s1czj60u42qrW1ART4l2AD4f/aA4FEf7AURzvMoogAEjajEhDrARTHkka2dTFuNIh/C+Zn1RH5aAGIsYZ6rRcGKeaRmKeqJDG2jb8mIN/EYjHycG6cyDweKgsHdQEnRVaqykqhzYZFGZMkD/uXoM0my2X5nhdrzKCZLOsfvg5CslwAYmNlTqRYJzFqiuVnlEGyPIoEy8hyI5hpEYT8PnlQse4BLC5zAvbcgiatrUWZD1rqUw+JkPHf6IsNKYpi/FcC0AXLUHSA5mGz3yYKoHNOwZIuTls6uU4w2NxV30W0CpbiaRQM1nM1RWweHIXYzuXKD2t6cca5XBFej64liG2C43TBNq65weAaKGHDicHgIldRxLauypFg15yCBYHTCLEHFKFFCdqiQIJKKNDLe322EpglOg6joAdAt+LIKQYh3bojkdfTCI0IvVQxr2BNuhRsvqKSWpFJHim/urbSio6M8fwgiyQoLa6Y3Jgu2J1maUQI5raJDafG26hq13g9VW0en8iJx8epjdRG/McVX6g28gPRwt6iBQPC3pI/LtHQz69E5Wt2x+MVoUQjtXfcadN7bHyRqraJ9wmrg3MLUn5o5Drbk78WdAQB4jwA6GZnDJhAol/+p+VMaEaJhsRk4MzALAH9QL8D7pjT6rd1DwmFXO55odBKt6AjNJwU6maYqDo1LV6EZRuCHTriqP6iYLzQMhRaxM9rV8OYIw73WH+olNvtzyUo6dnQCVojloIsfsQpwiZ67Fm9hMQSiay2kU+G4H7aNk4rc3C1tJnzzSLYg5KLs5wW30EkjUUwRqPcQwHt1y+dYvMTCQBILZ3fjx97LIIdKINU4IwTHZAQjemvATxzQulm5Tga1WFjOmjWEgiaVQMhVmrCAqmqnQH0275sw6n0hkcPDx9PZ2LSfNZvO6wlt1OaM6Exm2V8UDP9uBxRurTK2F+CRFdrngw2vynxU74TMV0wvWxp6tSy+7t3PNmzKZXOLM3MZzQDse7vndWQM1e4BSLnd22MmYnZA0C/XWtsrnA8EB5dcMOy1bDnxfMTN69vfjZ/6dJUJpPRVyiDqVgZOYWA0UZxqtj/KVi8fLJiMqn56tb1DUwmYxD2+TpBg4oVR4DUtO5ciHHBBFudPnvhyK6nL69e3rMJpO2p1IaGI5IT0VaXn+ULQSefr70QhIm+vsYdcK+6dVvnDeki611sF6NrZN9HNUWCjKXTLw9ee3/txKeL5x6leM6kUvalsNj8Rk1FQWVRmcJ8VBc21mqiukXDDs0VCXcAKIrD+2jjw9FouA3ihLBOtLI2KlG1JpMSqWUfnh94sOXGjfN3Tt57vCmzlEkNG3gGavMQ3ZqW1PcTi0/TRoLUW1uij/NIeEjeXtpJLwvEaSTYVtw0WPEAZGL21f3mn/3x/fSJo/v2nfy6+fLrQ+ceL01kGh6jXaLqARCCsqhPmIQmuadFTxwMUBL7AkzPI8hpsRrOXThy+8ibjbe+nfly9PrJjVd3v4WMPSVs1hDghK2JWf6/ghW0acXRp2njwpWAtY5y2iDHxwMajk7VNO3Vdun4i7sHdp1+cP/es49bjl7csWPHk72J1Z5X0zRtajTsZTR7+XnhSB9NZ0g4vIqHNDrkvxN/pmmaVF3QdFQ/Ib3p6cFdu05/3rnz3eEthy5tvLJx8975q8WqwIrZvClUANGczRsptX+1a94/SgRRHLf390bZEwEPEQ/uVBQPBKyApyhiubOfvffee++9xt5bYuwl0cRo1BgTE9sP/mo0/m40/ge+NzvuooCxJMYf/MS4O7B7X3Z25s0rMxHROsglIG9LcQl08tFY38Ti4TLfRHwLy3Z+fPTi2vUPt26fvPDmyeNTL89cPA2rRU+fz1emQbstxZIBFOMbQcAsX5s1g7w+X3lWry0BJ1QmajJPfM1wETUBW0lw/9A7Dx4+fPXwyutPb84+O3Pj+aVb04a+j98OyzGyAnW2pgsKdsNnA5Mp6KYklfJL5yjTZtIW30HJXSi5fOXsg88X71++cO/ezVtPYdmRwqf7hwKzwozQWNB8HTJMyOF5r10sza1uvCNNiW3qMSeRoLZ/9TJenZbJxWIo/Zt2UpsWt4R30YV0D928eDHZbUc9HMKnC2nUNl25uGUvELkEQXl528ygEnSieADItNHK1Aem9dH/B6ZPjziUITELdKYYDg7I2AIkOd4hIXg9PKc8KhU9SUftIGSnRw9IIuFQL3wJEpOBkdFTCUDuLh3duHFPnq9Thw1rPMyOGG2/pRAkC4oGJHpAFix5ggRja9qvaNyYjHfjxvNxYqT9InIzmBDWozNyMXIIbmM3Ydw3gatI+9MWTRCaRgc+KicqDk5EaaL90EvlP1fit4zMHa7NbD4Q0dOdKOBgxkAMSNHbkqgnLdSbg8bDiu7J5s1pjkd0WxpLQafu50PYortkVZsclsbNgjoLpaVhQZOSvAVNbAcCB4654tOPBwK2CU0skasTjs8p42mYQqZICYb1dW4T6EzKIYhcjJFTSLnhpqCyABFliLchU95DDsgd8ltkmkBDNJb/MkMwe4J2bNvRFhLElW07cjCzPgHW7wRXJDfRJJ5UuiQ5e1I0Gh0dLxwxaVIM7Rz3LGnLjOVgZh82a5QkWmAs2eiAyB6Q9kScBESpKtZ1Q7TAaPmuTYaoYMaN3dVLTEufqHDYw2YxjYU5ntBvt5eCECwYAMEBqa/cFbXbd7nyaEa4dA4jhaxezrhvcrksgqBv5iEjs4ku1z77FJdrCurE7DFEr2u8yCYo9JEOURYEAZqIxzAoRL5ezqv3NfXF10BX3WLSaVP8il3ATMSIOI4Ga8WxHGUEoTqIjjb5hHSm4pc23Ffr8SvDzNXOpmojCp/G6lvkPFS/bgAUI7co5M4UdK3ovFbEz3VO6l0qDnTu3I/zIYsdizRo7pg1Pz2519lBNO08k5Mj/SbiPIdjGHdpZ56Haw45PDh8sINY13mdw9EKQxmCTIB9oPBXmyCgEaKchxHQ6WoKKuYq8zmMI4exPBO86vIu1GBa8OWzKd2UY5SOAdFMJUIFbEdcAG2NNKdmNwWViW6kBH14mBrpgkvYtIFKfQXR3T+LoLBEigZ7CnoWrUPs6mkEML6ovMzjQ/R5iIUsuKmoyGkIHvN45qO9qChPiPaRQdQhnMKbypZmpMdD9rpNmzac3CsGsTmypjCbIMi8JBshIzBBxqw9LWHTMR90Fn5NWIlvU59radAYpOArMzIywiJx0LaBjffB/E00CmzEwdb5xEScvym/qe1qjLP6i/NlDvY4xbz8XSObbbrQJhynj/ahmz/ZWww2NNhm+8rM/L3tMzxvYwHOR50SIDZgK1U/TIIGqkCvbk7IZbaF4b4wLJjJnCwRsJliamxUZqQ1m68ix41ATEemGEA1zHKeHYzoLpN+mYLjrETHuCBsdMYN6rhg8Jy1OQi/1doCfcGgH9orwRHB9SNggNXaNxgcjgVW6xC2NB3WUzmBZksXq44PPXxY7sbGwfXFpmBuvGaUJSd+RyW4BaLcIBxqeWqEw0uMACgAOmX0DTPcCHNNS6NKQQq9jFMIo2OxAKR6NxkAha1iIcTmxhM2j8WseXlUbooRQer0WEEhDOS6kHSES5o0WcBRkRMgkddelREyil3uel9xu/ViVyqeKoRIvXozyZkIW9MFS+LhKfXIsBamGKHF4ykB4XC4jV4/7D283mAlOFba/Z8s50ksiMvVOO5oCMoOQ1CYczmkC7oQW0tB0/BP+FHBcvLkwUvVToXRXgfiBi+xrsHkiCE43evt16CpgJ7er8wQoqHXe6hBIxZcMHhyJyXYDd27B0+ePPnoT+w2UUZbkU8tQ7BU/mRBptlAmqoEB71tgVGCSzAEiszUlwCFuRdjH+qobNIaJUhmvRcLLjYXYOAFuJwn/i7QWYqHWdCtLGCWfKllX6sColXSFJzu3yUX0eP+5QWtRoHF79/Dggm/f2zBKgHj/Tr56C4o6Odf258FfQU6zbjgXt8/akjBCtCyCxq/Vgky41W1pKHqKwe7V6B8AUiPXw6pxJXCiN1UPeUnNn/kBQIJKHY6faQV6MvTQghY6HR2CkQA+jlbTwgUs48zLhCY7SzjxVE0DCySv8/plL5VaK7TG+jlxtaBwIDcezFMwYXyTRlxAgnqtECn2iswGEiwE19mIUEjkT9VhXr55rTo+TOC27hHiJlpgkJ6n0uV8Z4DmpyhpeBSZQSdElkh1QcN85O7TaZHoy7Y3K1bm3TB0XLPjsYBXDS6FoSj2+DS6BZdUHQojTLWsCgqLfXp83D4jNIlufZEoU5XJQjGimQICo7+QaKZWThCF0yPQ6CM95wFecBtzdWl80ISpyk4IDESsRltvwoNJ0HlipYnEu3GpUQJ771KLA0lDUEt0Y5IgU4rLEskxobmWWBGKOTPImhuMxMwWAmed7sRm1qIreoJSdDNdIBit7uZ213OlytBWEofuDsalgabuRdaLJqW6m/RMgV3Zew20U20Wvqs6rjYiFK2IAMK6RMgcyB9Da0Pih9vFRxzWAnmS6tWf+ACWDt7djkk6tfv22X7fJy3vYufK6RDunTx6nd4t3ehaKNplykkzO1RIFbQNsLZVIdYzu28jJJsBnnKv1ZlX0m5LJvNw6TKaHvNzTUyIjJ9mqQxgvKQmfCT62GZarhA45FXJB2iiTz8BGyRqZmpKBmuAeeLjYzwHGrID2Bc1onfv+73jAjL9Ui1UiqbULfueHrOutOBiNet6wKI6BeUg84CdcNmMzUwgtv9/8U9wsx/wf+CmYIVf4VKYFCp4u9R4ZeoVRkUlWtV+CvUAEWNCn+JaiCpVuFvUacqEFXrVPhr1K4CUKV2hb9IzUqValb4q1Sv/id3fwG7QOSdF/TjsQAAAABJRU5ErkJggg==",
      "alt": ""
    }
  }), _c('img', {
    staticClass: "teacherDownload",
    attrs: {
      "src": require("../../assets/images/client/teacherDownload.png"),
      "alt": "教师端下载"
    }
  })]), _c('div', {
    staticClass: "qrcodeText"
  }, [_c('div', [_c('p', {
    staticClass: "text"
  }, [_vm._v("关注爱云校公众号")]), _c('p', {
    staticClass: "text"
  }, [_vm._v("获取最新消息")])]), _c('div', [_c('p', {
    staticClass: "text"
  }, [_vm._v("教师端下载")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticStyle: {
      "padding-top": "15px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://beian.miit.gov.cn/",
      "target": "_blank"
    }
  }, [_vm._v("京ICP备2023035022号-12")]), _c('b', {
    attrs: {
      "data-v-68a7ffed": ""
    }
  }, [_vm._v("|")]), _c('a', {
    attrs: {
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502040800",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "gaba",
    attrs: {
      "src": require("../../assets/images/client/reference.png")
    }
  }), _c('p', {
    staticClass: "gabaText"
  }, [_vm._v("京公网安备11010702003156号")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3d7ca92e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/common/Footer.vue
// module id = 406
// module chunks = 0